<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col cols="4">
        <v-select
          v-model="diagnostico"
          :items="diagnosticos"
          item-text="nome"
          item-value="id"
          label="Diagnóstico:"
          return-object
        />
      </v-col>
    </v-row>
    <v-card-widget title="Dashboard">
      <div
        v-if="diagnosticos.length === 0"
        slot="widget-content"
      >
        <app-alert
          type="info"
          message="Não há diagnósticos disponíveis."
        />
      </div>
      <div
        v-else-if="!diagnostico"
        slot="widget-content"
      >
        <app-alert
          type="info"
          message="Selecione um diagnóstico."
        />
      </div>
      <div
        v-else
        slot="widget-content"
      >
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AppAlert from '@/components/core/AppAlert';
import VCardWidget from '@/components/VWidget';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardMonitoramentoDiagnostico',

  components: {
    VCardWidget,
    AppAlert,
    AppTimeline,
  },

  computed: {
    ...mapGetters({
      getDiagnostico: 'diagnostico/getDiagnostico',
      getDiagnosticos: 'diagnostico/getDiagnosticos',
    }),
    ...mapState({
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
    tipoAcesso() {
      if (this.comissao) {
        return 'COMISSAO';
      }
      if (this.chefia || this.substituicaoChefia) {
        return 'COMUM';
      }
      return null;
    },
    diagnostico: {
      get() {
        return this.getDiagnostico(this.tipoAcesso);
      },
      set(diagnostico) {
        if (this.comissao) {
          this.$store.dispatch('diagnostico/setDiagnosticoComissao', diagnostico);
        } else if (this.chefia || this.substituicaoChefia) {
          this.$store.dispatch('diagnostico/setDiagnostico', diagnostico);
        }
      },
    },
    diagnosticos() {
      return this.getDiagnosticos(this.tipoAcesso);
    },
    timelineItens() {
      return [
        {
          visibilidade: true,
          titulo: 'Diagnóstico comportamental (perspectiva comportamental)',
          textos: [
            'Como Gestor você pode acompanhar os resultados do diagnóstico comportamental.',
          ],
          cor: 'success',
          icone: 'thumbs_up_down',
          link: '/monitoramento/diagnostico/comportamental',
          dataInicial: this.diagnostico.inicioComportamental,
          dataFinal: this.diagnostico.fimComportamental,
        },
        {
          visibilidade: true,
          titulo: 'Diagnóstico Técnico (perspectiva responsabilidades)',
          textos: [
            'Como Gestor você pode acompanhar os resultados do diagnóstico técnico.',
          ],
          cor: 'secondary',
          icone: 'recent_actors',
          link: '/monitoramento/diagnostico/tecnico',
          dataInicial: this.diagnostico.inicioResponsabilidadeChefia,
          dataFinal: this.diagnostico.fimResponsabilidadeServidor,
        },
      ];
    },
  },

  created() {
    if (!this.comissao && !this.chefia && !this.substituicaoChefia) {
      this.$router.push('/403');
    }
  },
};
</script>
